import { Address } from '@vfde-sails/avc-core';
import { LmsForm, LmsFormDTO, Title } from '../interface';
import { StringMap } from '../../../interface';

const isGender = (gender?: string): gender is Title => Object.values(Title).includes(gender as Title);

const getStringProps = (props: Object): StringMap => {
    let stringProps: StringMap = {};

    for (const [key, value] of Object.entries(props)) {
        if (!value) {
            throw Error(`The following required property is not valid: '${key}', value: '${value}'`);
        }
        stringProps[key] = value.toString();
    }

    return stringProps;
};

/**
 * @example '2000-01-01 01:01:01'
 */
const getTimeStamp = () => {
    return new Date()
        .toISOString()
        .replace('T', ' ')
        .split('.')[0];
};

export const getlmsPayload = (lmsFormData: LmsForm, address: Address): LmsFormDTO | undefined => {
    const { firstName, lastName, email, salutation } = lmsFormData;
    const {
        city, street, housenumber, zipcode,
        housenumberextra, district,
    } = address;

    const requiredProps = getStringProps({
        firstName,
        lastName,
        email,
        city,
        street,
        housenumber,
        district,
        zipcode,
    });

    // construct object here to apply DTO type
    return {
        salutation: isGender(salutation) ? salutation : '',
        timestamp: getTimeStamp(),
        firstName: requiredProps.firstName,
        lastName: requiredProps.lastName,
        email: requiredProps.email,
        city: requiredProps.city,
        street: requiredProps.street,
        houseNumber: requiredProps.housenumber,
        houseNumberExtra: housenumberextra ? housenumberextra : null,
        district: requiredProps.district,
        zipcode: requiredProps.zipcode,
        referrer: window.location.host,
    };
};
